<template>
  <div>
    <header-nav :showMenu="false"></header-nav>
    <!-- wrapper -->
    <slot />
    <!-- wrapper -->
    <main-footer></main-footer>
  </div>
</template>

<script>
import HeaderNav from "../components/Header/Header";
import MainFooter from "../components/Footer/Footer";

export default {
  components: {
    MainFooter,
    HeaderNav
  },
  name: "default-layout"
};
</script>

<style scoped></style>
